import React from 'react';
import { ProjectRecruitingView } from '../projectWorkspace/ProjectRecruitingView';

export const CandidateTable = () => <ProjectRecruitingView mode="list" />;
